module.exports = __webpack_public_path__ + "img/icon-arrow-next.6ef51cd8.svg";